<template>
  <div>
    <hr/>
    
    <b-row class="my-3 align-items-center">
      <b-col cols="12" class="pb-3 fs-dbb-20">
        <div class="fs-dbb-20">
          {{ $t("engine.managePage.pageAddEdit.permission.member.lblMember", languageEngine) }}
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-15 align-items-center">
      <b-col cols="4">
        <label for="">
          {{ $t("engine.managePage.pageAddEdit.permission.member.lblMemberType", languageEngine) }}
          <span class="text-hint">({{ languageUse && languageUse.toUpperCase() }})</span>
          <span class="text-danger ml-3">*</span>
        </label>
      </b-col>
      <b-col cols="8">
        <b-dropdown
          id="dropdown-1"
          variant="light select-page"
          class="w-100"
          menu-class="w-100"
        >
          <template #button-content>
            <div class="d-flex justify-content-between align-items-center">
              <span>
                {{
                  capitalize(memberType) == "All"
                    ? $t("engine.managePage.pageAddEdit.permission.member.lblMemberTypeAll", languageEngine)
                    : $t("engine.managePage.pageAddEdit.permission.member.lblMemberTypeGroup", languageEngine)
                }}
              </span>
              <i class="far fa-angle-down"></i>
            </div>
          </template>
          <b-dropdown-item @click="memberType = 'all'">
            {{ $t("engine.managePage.pageAddEdit.permission.member.lblMemberTypeAll", languageEngine) }}
          </b-dropdown-item>
          <b-dropdown-item @click="memberType = 'groups'">
            {{ $t("engine.managePage.pageAddEdit.permission.member.lblMemberTypeGroup", languageEngine) }}
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <b-row class="mt-15 align-items-start" v-if="memberType === 'groups'">
      <b-col cols="4">
        <label for="">
          {{ $t("engine.managePage.pageAddEdit.permission.member.lblGroup", languageEngine) }}
        </label>
        <span class="text-danger ml-3">*</span>
      </b-col>
      <b-col cols="8" :class="{ errors: validateMemberGroupsID.$error }">
        <b-form-group class="mb-0">
          <b-form-checkbox
            v-for="option in groupType.filter((group) => group.name)"
            :key="option.id"
            v-model="memberGroupsID"
            :value="option.id"
          >
            {{ option.name }}
          </b-form-checkbox>
        </b-form-group>
        <small v-if="!validateMemberGroupsID.custom && validateMemberGroupsID.$error">{{ $t("engine.managePage.pageAddEdit.permission.member.errMemberGroup", languageEngine) }}</small>
      </b-col>
    </b-row>
    <ModalConfirmUpgrade 
      :modalID="'modal-confirm-upgrade-member'"
      @clear="$emit('clear')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import pageService from "@services/pageService.js";
import ModalConfirmUpgrade from "@components_system/Design/Modal/ModalConfirmUpgrade/ModalConfirmUpgrade.vue";

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    validate: {},
  },
  components: {
    ModalConfirmUpgrade,
  },
  data() {
    return {
      types: ["public", "password", "member"],
      groupType: [],
      showPassword: false,
      isHover: "",
    };
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      permissions: "design/permissionWebsite/permissions",
    }),
    memberType: {
      get() {
        return this.data.properties.permission.memberType;
      },
      set(val) {
        this.data.properties.permission.memberType = val;
      }
    },
    memberGroupsID: {
      get() {
        return this.data.properties.permission.memberGroupsID;
      },
      set(val) {
        this.data.properties.permission.memberGroupsID = val;
      }
    },
    validateMemberGroupsID() {
      return this.validate.data.properties.permission.memberGroupsID;
    },
    defaultMemberGroups() {
      return [
        {
          id: '0',
          name: this.$t(
            "engine.managePage.pageAddEdit.permission.member.lblDefaultMemberGroups",
            this.languageEngine
          ),
        },
      ];
    }
  },
  methods: {
    capitalize,
    getMemberGroup() {
      const language = this.languageUse;
      pageService.memberGroup({ language }).then((response) => {
        this.groupType = [...this.defaultMemberGroups, ...(response.data || [])];
      });
    },
  },
  mounted() {
    if(this.permissions.isPagePermission == 0) {
      this.$bvModal.show('modal-confirm-upgrade-member');
    }else {
      this.getMemberGroup();
    }
  },
};
</script>

<style lang="scss">
.type-permission.active {
  color: #212529 !important;
  /* background-color: #fff !important; */

  svg {
    border-radius: 8px;
  }
}
#setting-page-permission {
  .custom-control.custom-checkbox label {
    line-height: 20px;
  }
  input[type="password"]::-ms-reveal,
  input[type="password"]::-ms-clear {
    display: none;
  }
}
</style>
